import NumberFilter from './number'

export default (value, currency) => {
  if (!currency) {
    return value
  }

  try {
    return Intl.NumberFormat('lv-LV', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 8
    })
      .format(value)
  } catch (error) {
    const formattedValue = NumberFilter(value)
    return `${formattedValue} ${currency}`
  }
}
